import React from "react";
import styles from "./Backdrop.module.css";

const Backdrop = () => {
  return <div className={styles.container}></div>;
};

export default Backdrop;
